import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Maintenance } from '../models/maintenance';
import { MaintenanceType } from '../models/maintenance-type';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  constructor(private http:HttpClient) { }

  getMaintenances(date1:Date, date2:Date) : Promise<Maintenance[]> {
    return this.http.get<Maintenance[]>('/api/maintenance', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise()
  }

  storeMaintenance(maintenance:Maintenance, close:boolean = undefined) : Promise<Maintenance> {
    let data = close ? {close: close + ""} : {};
    return this.http.post<Maintenance>('/api/maintenance', maintenance, {params: data})
      .toPromise();
  }

  getMaintenanceTypes(): Promise<MaintenanceType[]>{
    return this.http.get<MaintenanceType[]>('/api/get/maintenance/types').toPromise()  
}
}
